import { EMPTY_FILTER_VALUE } from '../../../types/qualityEvent';

/**
 * react-select `filterOption` for the filter dropdowns that carry the reserved
 * "empty" option. That option's label is a styled (italic) node rather than
 * searchable text, so its own text (the node's children) is matched against
 * the search text like any other option; every other option is matched with a
 * case-insensitive substring on its (string) label.
 */
export const emptyAwareFilterOption = (option: any, searchText: string): boolean => {
  if (!searchText) {
    return true;
  }
  const search = searchText.toLowerCase();
  if (option.data.value === EMPTY_FILTER_VALUE) {
    return String(option.data.label?.props?.children ?? option.data.label ?? '')
      .toLowerCase()
      .includes(search);
  }
  return String(option.data.label).toLowerCase().includes(search);
};
